import { USER_PERMISSIONS } from 'dyl-components';
import AssignmentRulesTable from 'pages/AssignmentRules/SubComponents/AssignmentRulesTable';
import DistributionUsersTable from 'pages/AssignmentRules/SubComponents/DistributionUsersTable';

import React from 'react';
import { Route } from 'react-router-dom';
import RestrictedView from 'shared/RestrictedView';

export const ASSIGNMENT_RULES_ROUTES = [
    <Route path='assignment-rules' element={<RestrictedView type='restricted' userPermission={USER_PERMISSIONS.ASSIGNMENT_RULES_VIEW}><AssignmentRulesTable /></RestrictedView>} />,
    <Route path='distribution-users' element={<RestrictedView type='restricted' userPermission={USER_PERMISSIONS.ASSIGNMENT_RULES_VIEW}><DistributionUsersTable /></RestrictedView>} />,
];
